/* ============================================
   FITNIX BUNDLE PAGE JAVASCRIPT
   Handles step navigation, card selection, cart operations
   ============================================ */

(function() {
  'use strict';

  // State management
  const state = {
    currentStep: 'step-1',
    gripQuantities: { classic: 0, smart: 0 },
    selectedPath: null,
    selectedAccessories: [],
    currentKitVariantId: null
  };

  let _originalAddBtnHTML = '';

  // DOM Elements
  let elements = {};

  // Initialize on DOM ready
  document.addEventListener('DOMContentLoaded', init);

  function init() {
    cacheElements();
    setupGripQuantity();
    setupPathSelection();
    setupAccessoryCards();
    setupKitButtons();
    setupKitModal();
    setupLightbox();
    setupBackLinks();
    setupAddToCartButtons();
    setupComparison();
    setupReadMore();
    // Replace initial state so popstate knows starting step
    history.replaceState({ bundleStep: 'step-1' }, '', '');
    showStep('step-1', true);

    // Browser back/forward button navigates between bundle steps
    window.addEventListener('popstate', function(e) {
      if (e.state && e.state.bundleStep) {
        showStep(e.state.bundleStep, true);
      }
    });

    console.log('Bundle page initialized');
  }

  function cacheElements() {
    elements = {
      steps: document.querySelectorAll('.bundle-step'),
      bundleCards: document.querySelectorAll('.bundle-grip-card'),
      gripQtyInputs: document.querySelectorAll('.bundle-grip-card__quantity-input'),
      gripContinueBtn: document.getElementById('grip-continue-btn'),
      gripContinueHint: document.getElementById('grip-continue-hint'),
      pathCards: document.querySelectorAll('.bundle-path-card'),
      productCards: document.querySelectorAll('.bundle-product-card'),
      accessoryCheckboxes: document.querySelectorAll('.bundle-accessory-checkbox'),
      kitCards: document.querySelectorAll('.bundle-kit-card'),
      backLinks: document.querySelectorAll('.bundle-back-link'),
      skipToStep2Link: document.querySelector('[data-action="skip-to-step2"]'),
      // Selection UI elements
      selectionBadge: document.getElementById('selection-badge'),
      badgeCount: document.getElementById('badge-count'),
      stickyFooter: document.getElementById('sticky-footer'),
      footerCount: document.getElementById('footer-count'),
      footerTotal: document.getElementById('footer-total'),
      addSelectedBtn: document.getElementById('add-selected-btn'),
      inlineCartBtn: document.getElementById('inline-cart-btn'),
      inlineSummary: document.getElementById('selection-badge'),
      inlineTotal: document.getElementById('inline-total'),
      selectAllBtn: document.getElementById('select-all-btn'),
      // (Discount system removed per client feedback)
      // Kit modal elements
      kitModalWrapper: document.getElementById('kit-modal-wrapper'),
      kitModal: document.getElementById('kit-modal'),
      modalMainImage: document.getElementById('modal-main-image'),
      modalThumbnails: document.getElementById('modal-thumbnails'),
      modalTitle: document.getElementById('modal-title'),
      modalPrice: document.getElementById('modal-price'),
      modalComparePrice: document.getElementById('modal-compare-price'),
      modalSavings: document.getElementById('modal-savings'),
      modalDescription: document.getElementById('modal-description'),
      modalQuantityInput: document.getElementById('modal-quantity'),
      modalAddBtn: document.getElementById('modal-add-btn'),
      // Comparison modal elements
      compareModalWrapper: document.getElementById('compare-modal-wrapper'),
      compareModal: document.getElementById('compare-modal'),
      compareSelectBtns: document.querySelectorAll('[data-action="compare-select"]'),
      compareSelectBtnsExtra: null, // placeholder
      bottomCartBtn: document.getElementById('bottom-cart-btn'),
      bottomCartCount: document.getElementById('bottom-cart-count')
    };

    console.log('Cached elements:', {
      productCards: elements.productCards.length,
      accessoryCheckboxes: elements.accessoryCheckboxes.length,
      kitCards: elements.kitCards.length
    });
  }

  // ============================================
  // STEP NAVIGATION
  // ============================================

  function showStep(stepId, skipPush) {
    state.currentStep = stepId;

    // Push browser history so back button navigates between steps
    if (!skipPush) {
      history.pushState({ bundleStep: stepId }, '', '');
    }

    // When navigating to step-1, ensure comparison modal is closed
    if (stepId === 'step-1') {
      closeCompareModal();
    }

    elements.steps.forEach(step => {
      if (step.dataset.step === stepId) {
        step.classList.add('active');
      } else {
        step.classList.remove('active');
      }
    });
    
    // Show/hide sticky footer on step 2a
    if (elements.stickyFooter) {
      if (stepId === 'step-2a') {
        elements.stickyFooter.classList.add('visible');
      } else {
        elements.stickyFooter.classList.remove('visible');
      }
    }
    
    // Filter accessories/kits by selected grip type and update Swipers
    if (stepId === 'step-2a' || stepId === 'step-2b') {
      filterByGripType();

      setTimeout(function() {
        var accessoriesSwiper = document.querySelector('#accessories-swiper');
        if (accessoriesSwiper && accessoriesSwiper.swiper) {
          accessoriesSwiper.swiper.update();
          accessoriesSwiper.swiper.slideTo(0);
        }

        var kitsSwiper = document.querySelector('#kits-swiper');
        if (kitsSwiper && kitsSwiper.swiper) {
          kitsSwiper.swiper.update();
          kitsSwiper.swiper.slideTo(0);
        }

        // Re-init or update thumbnail swipers (they need visible container to calculate widths)
        document.querySelectorAll('.bundle-thumb-swiper').forEach(function(el) {
          if (el.swiper) {
            el.swiper.update();
          } else {
            var container = el.closest('.bundle-kit-card__thumbs');
            if (container) {
              new Swiper(el, {
                slidesPerView: 'auto',
                spaceBetween: 8,
                freeMode: true,
                watchOverflow: true,
                grabCursor: true,
                navigation: {
                  prevEl: container.querySelector('.bundle-thumb-nav--prev'),
                  nextEl: container.querySelector('.bundle-thumb-nav--next'),
                },
              });
            }
          }
        });
      }, 100);
    }
    
    // Scroll to top
    window.scrollTo({ top: 0, behavior: 'smooth' });

  }

  // ============================================
  // GRIP-TYPE FILTERING (Accessories & Kits)
  // ============================================

  function getSelectedGripType() {
    // Determine which grip type the user selected based on quantities
    if (state.gripQuantities.classic > 0 && state.gripQuantities.smart === 0) {
      return 'classic';
    } else if (state.gripQuantities.smart > 0 && state.gripQuantities.classic === 0) {
      return 'smart';
    }
    // If both or neither selected, show all
    return 'all';
  }

  function filterByGripType() {
    var gripType = getSelectedGripType();
    var allSlides = document.querySelectorAll('.swiper-slide[data-grip-type]');

    allSlides.forEach(function(slide) {
      var slideType = slide.dataset.gripType;
      var shouldShow = (gripType === 'all' || slideType === gripType || slideType === 'both');

      if (shouldShow) {
        slide.style.display = '';
      } else {
        slide.style.display = 'none';
        // Uncheck hidden accessories so they don't get added to cart
        var checkbox = slide.querySelector('.bundle-accessory-checkbox');
        if (checkbox && checkbox.checked) {
          checkbox.checked = false;
        }
      }
    });
  }

  // ============================================
  // STEP 1: GRIP QUANTITY SELECTION
  // ============================================

  function setupGripQuantity() {
    // Event delegation for grip qty +/- buttons
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('[data-action="grip-qty-minus"], [data-action="grip-qty-plus"]');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      const grip = btn.dataset.grip;
      const card = btn.closest('.bundle-grip-card');
      if (!card) return;

      const input = card.querySelector('.bundle-grip-card__quantity-input');
      if (!input) return;

      const v = parseInt(input.value, 10) || 0;
      if (btn.dataset.action === 'grip-qty-minus') {
        input.value = Math.max(0, v - 1);
      } else {
        input.value = Math.min(10, v + 1);
      }

      updateGripState();
    });


    // Direct change listeners on grip qty inputs (for manual typing)
    elements.gripQtyInputs.forEach(function(input) {
      input.addEventListener('change', function() {
        var v = parseInt(this.value, 10);
        if (isNaN(v) || v < 0) v = 0;
        if (v > 10) v = 10;
        this.value = v;
        updateGripState();
      });
    });

    // Continue button click handler
    if (elements.gripContinueBtn) {
      elements.gripContinueBtn.addEventListener('click', function(e) {
        e.preventDefault();

        var totalQty = state.gripQuantities.classic + state.gripQuantities.smart;
        if (totalQty === 0) return;

        // Build items array for grips with qty > 0
        var items = [];
        var parts = [];
        document.querySelectorAll('.bundle-grip-card').forEach(function(card) {
          var grip = card.dataset.grip;
          var qty = state.gripQuantities[grip] || 0;
          var variantId = card.dataset.variantId;

          if (qty > 0 && variantId) {
            items.push({
              id: parseInt(variantId, 10),
              quantity: qty
            });
            var label = grip === 'classic' ? 'Classic' : 'SMART';
            parts.push(qty + 'x ' + label);
          }
        });

        if (items.length > 0) {
          // Disable button while adding
          elements.gripContinueBtn.disabled = true;
          var origHtml = elements.gripContinueBtn.innerHTML;
          elements.gripContinueBtn.textContent = 'Adding to cart...';

          addToCartSilent(items).then(function() {
            showCartNotification(parts.join(' + ') + ' added to cart!');
            elements.gripContinueBtn.innerHTML = origHtml;
            elements.gripContinueBtn.disabled = false;
            showStep('step-2');
          }).catch(function(err) {
            console.error('Error adding grips to cart:', err);
            elements.gripContinueBtn.innerHTML = origHtml;
            elements.gripContinueBtn.disabled = false;
            // Navigate anyway on error (graceful degradation)
            showStep('step-2');
          });
        } else {
          // No variant IDs set — navigate without cart add
          showStep('step-2');
        }
      });
    }

    // "Already have" link — skip to step 2 without adding grips
    if (elements.skipToStep2Link) {
      elements.skipToStep2Link.addEventListener('click', function(e) {
        e.preventDefault();
        showStep('step-2');
      });
    }
  }

  function updateGripState() {
    // Read qty values from both inputs
    elements.gripQtyInputs.forEach(function(input) {
      var grip = input.dataset.grip;
      state.gripQuantities[grip] = parseInt(input.value, 10) || 0;
    });

    var totalQty = state.gripQuantities.classic + state.gripQuantities.smart;

    // Enable/disable Continue button
    if (elements.gripContinueBtn) {
      elements.gripContinueBtn.disabled = totalQty === 0;
    }

    // Show/hide hint text
    if (elements.gripContinueHint) {
      elements.gripContinueHint.style.display = totalQty > 0 ? 'none' : '';
    }

    // Toggle selected class on cards + update subtotals
    elements.bundleCards.forEach(function(card) {
      var grip = card.dataset.grip;
      var qty = state.gripQuantities[grip] || 0;
      var unitPrice = parseFloat(card.dataset.unitPrice) || 0;

      if (qty > 0) {
        card.classList.add('bundle-grip-card--selected');
      } else {
        card.classList.remove('bundle-grip-card--selected');
      }

      // Update subtotal display
      var subtotalEl = card.querySelector('.bundle-grip-card__subtotal');
      if (subtotalEl) {
        if (qty > 0 && unitPrice > 0) {
          var total = (unitPrice * qty).toFixed(2);
          subtotalEl.textContent = 'Subtotal: $' + total;
          subtotalEl.classList.add('visible');
        } else {
          subtotalEl.textContent = '';
          subtotalEl.classList.remove('visible');
        }
      }
    });
  }

  // Silent cart add — adds items without opening cart drawer
  function addToCartSilent(items) {
    console.log('addToCartSilent called:', items);

    var sectionId = getCartSectionId();

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: items, sections: sectionId, sections_url: window.location.pathname })
    })
    .then(function(response) { return response.json(); })
    .then(function(data) {
      if (data.description) throw new Error(data.description);
      // Silently update cart drawer content (badge count) without opening it
      updateCartDrawerSilent(data.sections, sectionId);
      return data;
    });
  }

  /**
   * Update the cart count badge and cart drawer content without opening
   * the drawer. Uses the theme's native update-nodes event so the
   * cart-drawer Web Component stays intact.
   */
  function updateCartDrawerSilent(sections, sectionId) {
    var sectionHtml = sections ? sections[sectionId] : null;
    if (sectionHtml) {
      applyCartSectionUpdate(sectionHtml);
    } else {
      // Fallback: fetch fresh section HTML
      fetch('/?sections=' + encodeURIComponent(sectionId))
        .then(function(r) { return r.json(); })
        .then(function(freshSections) {
          var html = freshSections[sectionId];
          if (html) applyCartSectionUpdate(html);
        })
        .catch(function() { /* silently fail */ });
    }
  }

  function applyCartSectionUpdate(sectionHtml) {
    var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    // Extract template content the same way the theme does:
    // find <template data-sidebar-template="CartDrawer">, then
    // clone template.content.firstElementChild (the .cart-drawer__body div).
    var template = doc.querySelector('[data-sidebar-template="' + cartDrawer.id + '"]');
    if (!template) return;
    var node = template.content.firstElementChild.cloneNode(true);

    // Update header cart count badge (CartCount is always mounted in the header)
    var newCount = node.querySelector('#NewCartCount');
    if (newCount) {
      document.querySelectorAll('#CartCount').forEach(function(el) {
        el.innerHTML = newCount.innerHTML;
      });
    }

    // Replicate the theme's purchaseHandler flow without opening the drawer:
    // 1. mount() inserts the old this.element into DOM → child components
    //    connect and register their update-nodes listeners on the cart-drawer.
    // 2. emit('update-nodes') → children find matching elements in `node`
    //    and replace their own content with the fresh data.
    // 3. updateEmptyStatus() → toggles is-empty attribute based on items.
    // The drawer stays visually hidden (no open() call) but its DOM content
    // is now up-to-date for when the user next opens it.
    cartDrawer.classList.remove('is-pre-empty');
    cartDrawer.removeAttribute('empty-cart');
    cartDrawer.mount();
    cartDrawer.emit('update-nodes', { node: node });
    cartDrawer.updateEmptyStatus();
  }

  // ============================================
  // STEP 2: PATH SELECTION
  // ============================================

  function setupPathSelection() {
    elements.pathCards.forEach(card => {
      card.addEventListener('click', function(e) {
        e.preventDefault();
        
        const path = this.dataset.path;
        state.selectedPath = path;
        
        console.log('Path selected:', path);
        
        // Highlight selected
        elements.pathCards.forEach(c => c.classList.remove('bundle-path-card--active'));
        this.classList.add('bundle-path-card--active');
        
        // Navigate
        if (path === 'build-your-own') {
          showStep('step-2a');
        } else if (path === 'ready-made-kits') {
          showStep('step-2b');
        }
      });
    });
  }

  // ============================================
  // STEP 2A: ACCESSORY CARD SELECTION
  // ============================================

  function setupAccessoryCards() {
    // Listen for checkbox changes
    elements.accessoryCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', function() {
        console.log('Card selected:', this.checked);
        // Show toast with product name
        var card = this.closest('.bundle-product-card') || this.closest('.swiper-slide');
        var nameEl = card ? card.querySelector('.bundle-product-card__title') : null;
        var name = nameEl ? nameEl.textContent.trim() : 'Item';
        if (name.length > 30) name = name.substring(0, 28) + '...';
        showToast(this.checked ? '\u2713 ' + name + ' added' : '\u2715 ' + name + ' removed', this.checked);
        updateSelectedAccessories();
      });
    });

    // Select All / Deselect All toggle
    if (elements.selectAllBtn) {
      elements.selectAllBtn.addEventListener('click', function() {
        var visible = getVisibleCheckboxes();
        var allChecked = visible.every(function(cb) { return cb.checked; });
        visible.forEach(function(cb) { cb.checked = !allChecked; });
        updateSelectedAccessories();
      });
    }

    // Quantity +/- on product cards (delegated so it works for dynamic content)
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('[data-action="qty-minus"], [data-action="qty-plus"]');
      if (!btn) return;
      const card = btn.closest('.bundle-product-card');
      if (!card) return;
      e.preventDefault();
      e.stopPropagation();
      const input = card.querySelector('.bundle-product-card__quantity-input');
      if (!input) return;
      const v = parseInt(input.value, 10) || 1;
      if (btn.dataset.action === 'qty-minus') {
        input.value = Math.max(1, v - 1);
      } else {
        input.value = Math.min(99, v + 1);
        // Auto-select the item when user increases quantity
        const checkbox = card.querySelector('.bundle-accessory-checkbox');
        if (checkbox && !checkbox.checked) checkbox.checked = true;
      }
      updateSelectedAccessories();
    });
  }

  // Return only checkboxes whose parent slide is visible (not hidden duplicates)
  function getVisibleCheckboxes() {
    return Array.from(elements.accessoryCheckboxes).filter(function(cb) {
      var slide = cb.closest('.swiper-slide');
      return !slide || slide.style.display !== 'none';
    });
  }

  function updateSelectedAccessories() {
    state.selectedAccessories = [];
    let totalCents = 0;
    let count = 0;

    getVisibleCheckboxes().forEach(checkbox => {
      const card = checkbox.closest('.bundle-product-card');

      if (checkbox.checked && card) {
        const variantId = card.dataset.variantId;
        const priceCents = parseInt(card.dataset.price, 10) || 0;
        const qtyInput = card.querySelector('.bundle-product-card__quantity-input');
        const qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
        const quantity = Math.min(99, Math.max(1, qty));
        state.selectedAccessories.push({
          variantId: variantId,
          price: priceCents,
          quantity: quantity
        });
        
        totalCents += priceCents * quantity;
        count += quantity;
      }
    });
    
    console.log('Total selected:', count, 'Total price (cents):', totalCents);
    
    // Update badge count
    if (elements.badgeCount) {
      elements.badgeCount.textContent = count;
    }

    // Update inline summary and cart button visibility
    if (elements.inlineSummary) {
      elements.inlineSummary.classList.toggle('has-selection', count > 0);
    }
    if (elements.inlineCartBtn) {
      elements.inlineCartBtn.classList.toggle('has-selection', count > 0);
      var inlineBtnText = elements.inlineCartBtn.querySelector('.bundle-inline-cart-btn__text');
      if (inlineBtnText) {
        inlineBtnText.textContent = count > 0 ? 'Add Bundle to Cart' : 'Add Bundle to Cart';
      }
    }
    if (elements.inlineTotal) {
      elements.inlineTotal.textContent = formatMoney(totalCents);
    }

    // Update old sticky footer (mobile fallback)
    var footerInfo = document.getElementById('footer-info');
    var footerEmpty = document.getElementById('footer-empty');
    if (count > 0) {
      if (footerInfo) footerInfo.style.display = '';
      if (footerEmpty) footerEmpty.style.display = 'none';
      if (elements.footerCount) elements.footerCount.textContent = count;
      if (elements.footerTotal) elements.footerTotal.textContent = formatMoney(totalCents);
    } else {
      if (footerInfo) footerInfo.style.display = 'none';
      if (footerEmpty) footerEmpty.style.display = '';
    }
    if (elements.addSelectedBtn) {
      var btnText = elements.addSelectedBtn.querySelector('.bundle-sticky-footer__btn-text');
      if (btnText) {
        btnText.textContent = count > 0 ? 'Add Bundle to Cart' : 'Add Bundle to Cart';
      }
    }
    // Update Select All / Deselect All button text
    if (elements.selectAllBtn) {
      var visible = getVisibleCheckboxes();
      var allChecked = visible.length > 0 && visible.every(function(cb) { return cb.checked; });
      elements.selectAllBtn.textContent = allChecked ? 'Deselect All' : 'Select All';
    }
  }

  // ============================================
  // KIT DESCRIPTION PARSER
  // ============================================

  // ============================================
  // STEP 2B: KIT BUTTONS (Open Modal)
  // ============================================

  function setupKitButtons() {
    document.querySelectorAll('[data-action="open-kit-modal"]').forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();

        const card = this.closest('.bundle-kit-card');
        if (!card) return;

        // Read structured data from Liquid-rendered data attributes (metafields)
        var includes = [];
        try { includes = JSON.parse(card.dataset.kitIncludes || '[]'); } catch(e) { includes = []; }
        // Handle Liquid outputting null for nil metafields
        if (!Array.isArray(includes)) includes = [];

        const kitData = {
          variantId: card.dataset.variantId,
          available: card.dataset.kitAvailable !== 'false',
          name: card.dataset.kitName,
          price: card.dataset.kitPrice,
          comparePrice: card.dataset.kitComparePrice,
          savings: card.dataset.kitSavings,
          subtitle: card.dataset.kitSubtitle || '',
          includesHeading: card.dataset.kitIncludesHeading || 'Includes',
          includes: includes,
          note: card.dataset.kitNote || '',
          descriptionHTML: (card.querySelector('.bundle-kit-card__description-html') || {}).innerHTML || '',
          mainImage: card.dataset.kitImage,
          images: card.dataset.kitImages ? card.dataset.kitImages.split(',').filter(Boolean) : []
        };

        openKitModal(kitData);
      });
    });

    // Initialize thumbnail Swipers
    initThumbSwipers();
  }

  function initThumbSwipers() {
    document.querySelectorAll('.bundle-kit-card__thumbs').forEach(function(container) {
      var swiperEl = container.querySelector('.bundle-thumb-swiper');
      if (!swiperEl || swiperEl.swiper) return;

      // Skip if container is hidden (0 width) — will init when step becomes visible
      if (container.offsetWidth === 0) return;

      new Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 8,
        freeMode: true,
        watchOverflow: true,
        grabCursor: true,
        navigation: {
          prevEl: container.querySelector('.bundle-thumb-nav--prev'),
          nextEl: container.querySelector('.bundle-thumb-nav--next'),
        },
      });
    });
  }

  // ============================================
  // KIT MODAL FUNCTIONALITY
  // ============================================

  function setupKitModal() {
    if (!elements.kitModal) return;

    // Capture original Add to Cart button markup once at init
    if (elements.modalAddBtn) {
      _originalAddBtnHTML = elements.modalAddBtn.innerHTML;
    }

    // Close modal on overlay click
    document.querySelectorAll('[data-action="close-modal"]').forEach(el => {
      el.addEventListener('click', closeKitModal);
    });
    
    // Close modal on ESC key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && elements.kitModal.classList.contains('open')) {
        closeKitModal();
      }
    });
    
    // Add to cart from modal
    if (elements.modalAddBtn) {
      elements.modalAddBtn.addEventListener('click', function(e) {
        e.preventDefault();
        
        if (!state.currentKitVariantId) return;
        
        this.classList.add('loading');
        const originalText = this.innerHTML;
        this.innerHTML = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M3 3H4.5L5.5 13H14.5L16 5H6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="7" cy="16" r="1.5" fill="currentColor"/><circle cx="13" cy="16" r="1.5" fill="currentColor"/></svg> Adding...';
        
        const qty = elements.modalQuantityInput ? (parseInt(elements.modalQuantityInput.value, 10) || 1) : 1;
        const safeQty = Math.min(99, Math.max(1, qty));
        addToCart(state.currentKitVariantId, safeQty).then(() => {
          showCartNotification(safeQty > 1 ? 'Kits added to cart!' : 'Kit added to cart!');
          this.innerHTML = originalText;
          this.classList.remove('loading');
          closeKitModal();
        }).catch(err => {
          console.error('Error adding kit to cart:', err);
          var outOfStockMsg = (window.auroraThemeLocales && window.auroraThemeLocales.variantStrings && window.auroraThemeLocales.variantStrings.soldOut) || 'Out of Stock';
          this.innerHTML = (err && err.status === 422) ? outOfStockMsg : 'Error - Retry';
          this.classList.remove('loading');
          setTimeout(() => {
            this.innerHTML = originalText;
          }, 2000);
        });
      });
    }
    
    // Quantity +/- in modal
    if (elements.kitModal) {
      elements.kitModal.querySelector('[data-action="quantity-minus"]')?.addEventListener('click', function() {
        if (!elements.modalQuantityInput) return;
        const v = parseInt(elements.modalQuantityInput.value, 10) || 1;
        elements.modalQuantityInput.value = Math.max(1, v - 1);
      });
      elements.kitModal.querySelector('[data-action="quantity-plus"]')?.addEventListener('click', function() {
        if (!elements.modalQuantityInput) return;
        const v = parseInt(elements.modalQuantityInput.value, 10) || 1;
        elements.modalQuantityInput.value = Math.min(99, v + 1);
      });
    }

    // Click modal main image to open lightbox
    var modalMainWrap = elements.kitModal.querySelector('.bundle-kit-modal__main-image');
    if (modalMainWrap) {
      modalMainWrap.addEventListener('click', function() {
        var thumbEls = elements.modalThumbnails ? elements.modalThumbnails.querySelectorAll('.bundle-kit-modal__thumbnail img') : [];
        var images = [];
        thumbEls.forEach(function(img) { images.push(img.src); });
        if (images.length === 0 && elements.modalMainImage && elements.modalMainImage.src) {
          images.push(elements.modalMainImage.src);
        }
        // Find current active index
        var activeIndex = 0;
        var activeThumbs = elements.modalThumbnails ? elements.modalThumbnails.querySelectorAll('.bundle-kit-modal__thumbnail') : [];
        activeThumbs.forEach(function(t, i) {
          if (t.classList.contains('active')) activeIndex = i;
        });
        openLightbox(images, activeIndex);
      });
    }
  }

  function openKitModal(kitData) {
    if (!elements.kitModal) return;
    
    // Store variant ID for cart button
    state.currentKitVariantId = kitData.variantId;
    
    // Populate modal content
    if (elements.modalTitle) {
      elements.modalTitle.textContent = kitData.name || '';
    }
    
    if (elements.modalPrice) {
      elements.modalPrice.textContent = kitData.price || '';
    }
    
    if (elements.modalComparePrice) {
      if (kitData.comparePrice) {
        elements.modalComparePrice.textContent = kitData.comparePrice;
        elements.modalComparePrice.style.display = '';
      } else {
        elements.modalComparePrice.style.display = 'none';
      }
    }

    if (elements.modalSavings) {
      if (kitData.savings) {
        elements.modalSavings.textContent = 'Save ' + kitData.savings + '%';
        elements.modalSavings.style.display = '';
      } else {
        elements.modalSavings.style.display = 'none';
      }
    }
    
    // Description: subtitle + includes list (from metafield data attributes)
    if (elements.modalDescription) {
      var descHtml = '';
      if (kitData.subtitle) {
        var lines = kitData.subtitle.split('\n').filter(function(l) { return l.trim(); });
        descHtml += lines.map(function(l) {
          return '<p class="bundle-kit-modal__subtitle">' + l.trim() + '</p>';
        }).join('');
      }
      if (kitData.includes.length > 0) {
        descHtml += '<h3>' + kitData.includesHeading + '</h3>';
        descHtml += '<ul>' + kitData.includes.map(function(item) {
          return '<li>' + item + '</li>';
        }).join('') + '</ul>';
      }
      elements.modalDescription.innerHTML = descHtml;
    }

    // Note
    var noteEl = elements.kitModal.querySelector('.bundle-kit-modal__note');
    if (noteEl) {
      if (kitData.note) {
        noteEl.textContent = kitData.note;
        noteEl.style.display = '';
      } else {
        noteEl.style.display = 'none';
      }
    }

    // Description (rich text HTML from product.description via hidden div)
    var bottomTextEl = document.getElementById('modal-bottom-text');
    if (bottomTextEl) {
      bottomTextEl.innerHTML = kitData.descriptionHTML;
      bottomTextEl.style.display = kitData.descriptionHTML.trim() ? '' : 'none';
    }

    if (elements.modalQuantityInput) {
      elements.modalQuantityInput.value = '1';
    }
    
    // Set main image
    if (elements.modalMainImage) {
      elements.modalMainImage.src = kitData.mainImage || '';
      elements.modalMainImage.alt = kitData.name || '';
    }
    
    // Build thumbnails
    if (elements.modalThumbnails) {
      elements.modalThumbnails.innerHTML = '';
      
      const allImages = kitData.images.length > 0 ? kitData.images : (kitData.mainImage ? [kitData.mainImage] : []);
      
      allImages.forEach((imgUrl, index) => {
        const thumb = document.createElement('div');
        thumb.className = 'bundle-kit-modal__thumbnail' + (index === 0 ? ' active' : '');
        thumb.innerHTML = '<img src="' + imgUrl + '" alt="' + (kitData.name || '') + ' image ' + (index + 1) + '">';
        
        thumb.addEventListener('click', function() {
          if (!elements.modalMainImage || elements.modalMainImage.src === imgUrl) return;
          // Fade out, swap, fade in
          elements.modalMainImage.classList.add('fading');
          setTimeout(function() {
            elements.modalMainImage.src = imgUrl;
            elements.modalMainImage.classList.remove('fading');
          }, 200);
          // Update active thumbnail
          elements.modalThumbnails.querySelectorAll('.bundle-kit-modal__thumbnail').forEach(t => {
            t.classList.remove('active');
          });
          this.classList.add('active');
        });
        
        elements.modalThumbnails.appendChild(thumb);
      });
    }
    
    // Out-of-stock badge on image (top-right)
    const oosBadge = document.getElementById('modal-oos-badge');
    if (oosBadge) {
      oosBadge.style.display = kitData.available ? 'none' : '';
    }

    // Add to Cart button — show "Out of Stock" and disable when unavailable
    if (elements.modalAddBtn) {
      elements.modalAddBtn.innerHTML = _originalAddBtnHTML;
      elements.modalAddBtn.disabled = false;
      if (!kitData.available) {
        elements.modalAddBtn.innerHTML = 'Out of Stock';
        elements.modalAddBtn.disabled = true;
      }
    }

    // Show modal (wrapper gets .open so it stacks above theme footer)
    if (elements.kitModalWrapper) elements.kitModalWrapper.classList.add('open');
    elements.kitModal.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeKitModal() {
    if (!elements.kitModal) return;

    if (elements.kitModalWrapper) elements.kitModalWrapper.classList.remove('open');
    elements.kitModal.classList.remove('open');
    document.body.style.overflow = '';
    state.currentKitVariantId = null;
  }

  // ============================================
  // IMAGE LIGHTBOX (for kit card thumbnails)
  // ============================================

  var lightboxState = { images: [], currentIndex: 0 };

  function setupLightbox() {
    var lightbox = document.getElementById('image-lightbox');
    if (!lightbox) return;

    // Close lightbox handlers
    document.querySelectorAll('[data-action="close-lightbox"]').forEach(function(el) {
      el.addEventListener('click', closeLightbox);
    });

    // Prev / Next handlers
    var prevBtn = lightbox.querySelector('[data-action="lightbox-prev"]');
    var nextBtn = lightbox.querySelector('[data-action="lightbox-next"]');
    if (prevBtn) prevBtn.addEventListener('click', function() { lightboxNavigate(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { lightboxNavigate(1); });

    // Click on image to navigate: left half = prev, right half = next
    var lightboxImg = document.getElementById('lightbox-image');
    if (lightboxImg) {
      lightboxImg.addEventListener('click', function(e) {
        var rect = this.getBoundingClientRect();
        var clickX = e.clientX - rect.left;
        if (clickX < rect.width / 2) {
          lightboxNavigate(-1);
        } else {
          lightboxNavigate(1);
        }
      });
      lightboxImg.style.cursor = 'pointer';
    }

    // Swipe to navigate on touch devices
    var swipeStartX = 0;
    var swipeStartY = 0;
    var isSwiping = false;

    lightbox.addEventListener('touchstart', function(e) {
      swipeStartX = e.touches[0].clientX;
      swipeStartY = e.touches[0].clientY;
      isSwiping = true;
    }, { passive: true });

    lightbox.addEventListener('touchend', function(e) {
      if (!isSwiping) return;
      isSwiping = false;
      var dx = e.changedTouches[0].clientX - swipeStartX;
      var dy = e.changedTouches[0].clientY - swipeStartY;
      // Only trigger if horizontal swipe is dominant and long enough
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
        lightboxNavigate(dx < 0 ? 1 : -1);
      }
    }, { passive: true });

    // Keyboard navigation
    document.addEventListener('keydown', function(e) {
      if (!lightbox.classList.contains('open')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') lightboxNavigate(-1);
      if (e.key === 'ArrowRight') lightboxNavigate(1);
    });

    // Thumbnail click: swap main image in kit card (like grip thumbnails)
    document.querySelectorAll('[data-action="preview-image"]').forEach(function(thumb) {
      thumb.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var card = this.closest('.bundle-kit-card');
        if (!card) return;

        var mainImg = card.querySelector('.bundle-kit-card__image');
        var fullUrl = this.dataset.fullImage;
        if (!mainImg || !fullUrl) return;

        // Swap main image with fade
        mainImg.classList.add('fading');
        setTimeout(function() {
          mainImg.src = fullUrl;
          mainImg.onload = function() {
            mainImg.classList.remove('fading');
          };
        }, 200);

        // Highlight active thumbnail
        card.querySelectorAll('.bundle-kit-card__thumb').forEach(function(t) {
          t.classList.remove('active');
        });
        this.classList.add('active');
      });
    });

    // Swipe on kit card main image to navigate between images
    document.querySelectorAll('.bundle-kit-card__image-wrap').forEach(function(wrap) {
      var swipeStartX = 0, swipeStartY = 0, isSwiping = false;

      wrap.addEventListener('touchstart', function(e) {
        swipeStartX = e.touches[0].clientX;
        swipeStartY = e.touches[0].clientY;
        isSwiping = true;
      }, { passive: true });

      wrap.addEventListener('touchend', function(e) {
        if (!isSwiping) return;
        isSwiping = false;
        var dx = e.changedTouches[0].clientX - swipeStartX;
        var dy = e.changedTouches[0].clientY - swipeStartY;
        if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy)) return;

        var card = wrap.closest('.bundle-kit-card');
        if (!card) return;
        var thumbs = Array.from(card.querySelectorAll('.bundle-kit-card__thumb'));
        if (thumbs.length === 0) return;

        // Find current active index
        var activeIndex = 0;
        thumbs.forEach(function(t, i) {
          if (t.classList.contains('active')) activeIndex = i;
        });

        // Swipe left = next, swipe right = prev
        var newIndex = dx < 0 ? activeIndex + 1 : activeIndex - 1;
        if (newIndex < 0) newIndex = thumbs.length - 1;
        if (newIndex >= thumbs.length) newIndex = 0;

        // Trigger the thumbnail click
        thumbs[newIndex].click();
      }, { passive: true });
    });
  }

  function openLightbox(images, startIndex) {
    var lightbox = document.getElementById('image-lightbox');
    var img = document.getElementById('lightbox-image');
    if (!lightbox || !img) return;

    lightboxState.images = images;
    lightboxState.currentIndex = startIndex || 0;

    img.src = images[lightboxState.currentIndex];
    img.alt = 'Image ' + (lightboxState.currentIndex + 1) + ' of ' + images.length;
    updateLightboxUI();

    lightbox.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    var lightbox = document.getElementById('image-lightbox');
    if (!lightbox) return;

    lightbox.classList.remove('open');
    document.body.style.overflow = '';
  }

  function lightboxNavigate(dir) {
    var newIndex = lightboxState.currentIndex + dir;
    if (newIndex < 0 || newIndex >= lightboxState.images.length) return;

    var img = document.getElementById('lightbox-image');
    if (!img) return;

    // Fade out, swap, fade in
    img.classList.add('fading');
    setTimeout(function() {
      lightboxState.currentIndex = newIndex;
      img.src = lightboxState.images[newIndex];
      img.alt = 'Image ' + (newIndex + 1) + ' of ' + lightboxState.images.length;
      img.classList.remove('fading');
      updateLightboxUI();
    }, 200);
  }

  function updateLightboxUI() {
    var lightbox = document.getElementById('image-lightbox');
    if (!lightbox) return;

    var counter = document.getElementById('lightbox-counter');
    var prevBtn = lightbox.querySelector('[data-action="lightbox-prev"]');
    var nextBtn = lightbox.querySelector('[data-action="lightbox-next"]');

    if (counter) {
      counter.textContent = (lightboxState.currentIndex + 1) + ' / ' + lightboxState.images.length;
    }
    if (prevBtn) {
      prevBtn.disabled = lightboxState.currentIndex === 0;
    }
    if (nextBtn) {
      nextBtn.disabled = lightboxState.currentIndex === lightboxState.images.length - 1;
    }
  }

  // ============================================
  // COMPARISON TABLE
  // ============================================

  function setupComparison() {
    // Close modal on overlay click or X button
    document.querySelectorAll('[data-action="close-compare-modal"]').forEach(function(el) {
      el.addEventListener('click', closeCompareModal);
    });

    // Close modal on ESC key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && elements.compareModalWrapper && elements.compareModalWrapper.classList.contains('open')) {
        closeCompareModal();
      }
    });

    // CTA buttons: "Select Classic" / "Select SMART"
    elements.compareSelectBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var grip = this.dataset.grip;
        if (!grip) return;

        // 1. Close modal
        closeCompareModal();

        // 2. Set quantity = 1 on the selected grip card
        var card = document.querySelector('.bundle-grip-card[data-grip="' + grip + '"]');
        if (card) {
          var input = card.querySelector('.bundle-grip-card__quantity-input');
          if (input) {
            input.value = 1;
          }
        }

        // 3. Update grip state (enables Continue button, updates subtotals)
        updateGripState();

        // 4. Scroll to grip cards after a brief delay for modal close
        setTimeout(function() {
          var gripGrid = document.querySelector('.bundle-grip-grid');
          if (gripGrid) {
            gripGrid.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }

          // 5. Brief highlight on the selected card (300-500ms)
          if (card) {
            card.classList.add('bundle-grip-card--highlight');
            setTimeout(function() {
              card.classList.remove('bundle-grip-card--highlight');
            }, 500);
          }
        }, 200);
      });
    });
  }

  function openCompareModal() {
    if (!elements.compareModalWrapper) return;
    elements.compareModalWrapper.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeCompareModal() {
    if (!elements.compareModalWrapper) return;
    elements.compareModalWrapper.classList.remove('open');
    document.body.style.overflow = '';
  }

  // ============================================
  // READ MORE (inline expand/collapse)
  // ============================================

  function setupReadMore() {
    // Use event delegation so it works for elements in hidden steps too
    document.addEventListener('click', function(e) {
      var toggle = e.target.closest('[data-read-more-toggle]');
      if (!toggle) return;
      e.preventDefault();
      e.stopPropagation();
      var block = toggle.closest('[data-read-more]');
      if (block) {
        block.classList.toggle('is-expanded');
      }
    });

  }

  // ============================================
  // BACK LINKS
  // ============================================

  function setupBackLinks() {
    elements.backLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        const targetStep = this.dataset.targetStep;
        if (targetStep) {
          showStep(targetStep);
        }
      });
    });

    // "Compare Models" link opens comparison modal
    var compareBtn = document.querySelector('[data-action="show-compare"]');
    if (compareBtn) {
      compareBtn.addEventListener('click', function(e) {
        e.preventDefault();
        openCompareModal();
      });
    }
  }

  // ============================================
  // ADD TO CART
  // ============================================

  function setupAddToCartButtons() {
    if (elements.addSelectedBtn) {
      console.log('Setting up Add Selected button');
      
      elements.addSelectedBtn.addEventListener('click', function(e) {
        e.preventDefault();
        
        console.log('Add Selected clicked, accessories:', state.selectedAccessories.length);
        
        if (state.selectedAccessories.length === 0) {
          // No items selected — proceed to cart
          openCartDrawer();
          return;
        }
        
        // Disable button while processing
        this.disabled = true;
        this.classList.add('is-loading');
        if (elements.inlineCartBtn) {
          elements.inlineCartBtn.disabled = true;
          elements.inlineCartBtn.classList.add('is-loading');
        }
        const btnText = this.querySelector('.bundle-sticky-footer__btn-text');
        const originalText = btnText ? btnText.textContent : this.textContent;
        if (btnText) {
          btnText.textContent = 'Adding to Cart...';
        } else {
          this.textContent = 'Adding to Cart...';
        }
        if (elements.inlineCartBtn) {
          var topText = elements.inlineCartBtn.querySelector('.bundle-inline-cart-btn__text');
          if (topText) topText.textContent = 'Adding to Cart...';
        }
        
        const items = state.selectedAccessories.map(acc => ({
          id: parseInt(acc.variantId, 10),
          quantity: Math.min(99, Math.max(1, acc.quantity || 1)),
          properties: { 'Bundle': 'Build Your Own' }
        }));
        
        console.log('Adding bundle to cart:', items);
        
        addMultipleToCart(items).then((response) => {
          console.log('Cart response:', response);
          showCartNotification(items.length + ' items added as bundle!');

          // Reset checkboxes and quantity inputs
          elements.accessoryCheckboxes.forEach(cb => cb.checked = false);
          document.querySelectorAll('.bundle-product-card__quantity-input').forEach(inp => { inp.value = '1'; });

          // Reset checkboxes and update state
          updateSelectedAccessories();

          this.classList.remove('is-loading');
          this.classList.add('is-success');
          if (elements.inlineCartBtn) {
            elements.inlineCartBtn.classList.remove('is-loading');
            elements.inlineCartBtn.classList.add('is-success');
          }
          if (btnText) {
            btnText.textContent = 'Added!';
          } else {
            this.textContent = 'Added!';
          }
          if (elements.inlineCartBtn) {
            var topText = elements.inlineCartBtn.querySelector('.bundle-inline-cart-btn__text');
            if (topText) topText.textContent = 'Added!';
          }

          // Ensure cart drawer is open so user can see items and proceed to checkout
          // (purchaseHandler should open it, but this is a safety fallback)
          setTimeout(() => {
            var drawer = document.querySelector('cart-drawer');
            if (!drawer || !drawer.isOpen) {
              openCartDrawer();
            }
          }, 800);

          setTimeout(() => {
            // After reset, count is 0 — hide notify bar and reset states
            this.classList.remove('is-success');
            if (btnText) {
              btnText.textContent = 'Add Bundle to Cart';
            } else {
              this.textContent = 'Add Bundle to Cart';
            }
            this.disabled = false;
            if (elements.inlineCartBtn) {
              elements.inlineCartBtn.classList.remove('is-success');
              elements.inlineCartBtn.disabled = false;
              var topText = elements.inlineCartBtn.querySelector('.bundle-inline-cart-btn__text');
              if (topText) topText.textContent = 'Add Bundle to Cart';
            }
          }, 2500);
        }).catch(err => {
          console.error('Error adding to cart:', err);
          this.classList.remove('is-loading');
          if (elements.inlineCartBtn) {
            elements.inlineCartBtn.classList.remove('is-loading');
          }
          if (btnText) {
            btnText.textContent = 'Error - Retry';
          } else {
            this.textContent = 'Error - Retry';
          }
          setTimeout(() => {
            if (btnText) {
              btnText.textContent = originalText;
            } else {
              this.textContent = originalText;
            }
            this.disabled = false;
            if (elements.inlineCartBtn) {
              elements.inlineCartBtn.disabled = false;
              var topText = elements.inlineCartBtn.querySelector('.bundle-inline-cart-btn__text');
              if (topText) topText.textContent = originalText;
            }
          }, 2000);
        });
      });
    }

    // Top "Proceed to Cart" button — triggers the same action as the sticky footer button
    if (elements.inlineCartBtn) {
      elements.inlineCartBtn.addEventListener('click', function(e) {
        e.preventDefault();
        if (elements.addSelectedBtn) {
          elements.addSelectedBtn.click();
        } else {
          openCartDrawer();
        }
      });
    }

    // Bottom "Add to Cart" button — triggers the same action as the sticky footer button
    if (elements.bottomCartBtn) {
      elements.bottomCartBtn.addEventListener('click', function(e) {
        e.preventDefault();
        if (elements.addSelectedBtn) {
          elements.addSelectedBtn.click();
        } else {
          openCartDrawer();
        }
      });
    }
  }

  // ============================================
  // CART HELPERS — uses theme's native cart-drawer update
  // ============================================

  function getCartSectionId() {
    var cartDrawer = document.querySelector('cart-drawer');
    return cartDrawer ? (cartDrawer.dataset.sectionId || 'cart-drawer') : 'cart-drawer';
  }

  function addToCart(variantId, quantity) {
    quantity = quantity || 1;

    var sectionId = getCartSectionId();
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity);
    formData.append('sections', sectionId);
    formData.append('sections_url', window.location.pathname);

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
    .then(function(response) { return response.text(); })
    .then(function(text) {
      var data = JSON.parse(text);
      if (data.status && data.status >= 400) {
        var cartErr = new Error(data.description || data.message || 'Cart error');
        cartErr.status = data.status;
        throw cartErr;
      }

      var parsedState = { id: data.id, quantity: data.quantity, variant_id: data.variant_id };
      refreshCartDrawer(data.sections, sectionId, parsedState);
      return data;
    });
  }

  function addMultipleToCart(items) {

    var sectionId = getCartSectionId();

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: items,
        sections: sectionId,
        sections_url: window.location.pathname
      })
    })
    .then(function(response) { return response.json(); })
    .then(function(data) {
      var firstItem = (data.items && data.items.length) ? data.items[0] : {};
      var parsedState = { id: firstItem.id, quantity: firstItem.quantity, variant_id: firstItem.variant_id };
      refreshCartDrawer(data.sections, sectionId, parsedState);
      return data;
    });
  }

  /**
   * Refresh & open the cart drawer using the theme's native purchaseHandler.
   * If section HTML was returned from the add response, use it directly.
   * Otherwise fetch fresh section HTML from Shopify first.
   */
  function refreshCartDrawer(sections, sectionId, parsedState) {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || typeof cartDrawer.purchaseHandler !== 'function') {
      openCartDrawer();
      return;
    }

    var sectionHtml = sections ? sections[sectionId] : null;

    if (sectionHtml) {
      var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
      cartDrawer.purchaseHandler(doc, parsedState || {}).catch(function() {
        fetchFreshAndUpdate(cartDrawer, sectionId, parsedState);
      });
    } else {
      fetchFreshAndUpdate(cartDrawer, sectionId, parsedState);
    }
  }

  function fetchFreshAndUpdate(cartDrawer, sectionId, parsedState) {
    fetch('/?sections=' + encodeURIComponent(sectionId))
      .then(function(r) { return r.json(); })
      .then(function(sections) {
        var html = sections[sectionId];
        if (html && typeof cartDrawer.purchaseHandler === 'function') {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          cartDrawer.purchaseHandler(doc, parsedState || {}).catch(function() {
            openCartDrawer();
          });
        } else {
          openCartDrawer();
        }
      })
      .catch(function() {
        openCartDrawer();
      });
  }

  function openCartDrawer() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
      return;
    }

    // Fallback: click the cart button
    var btn = document.querySelector('[data-sidebar-button="cart"]')
           || document.querySelector('.cart-icon-bubble')
           || document.querySelector('a[href="/cart"]');
    if (btn) btn.click();
  }

  // ============================================
  // UTILITIES
  // ============================================

  function formatMoney(cents) {
    const dollars = (cents / 100).toFixed(2);
    return '$' + dollars;
  }

  var _toastTimer = null;
  function showToast(message, isAdded) {
    var existing = document.querySelector('.bundle-toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.className = 'bundle-toast ' + (isAdded ? 'bundle-toast--added' : 'bundle-toast--removed');
    toast.textContent = message;
    document.body.appendChild(toast);

    requestAnimationFrame(function() {
      toast.classList.add('is-visible');
    });

    clearTimeout(_toastTimer);
    _toastTimer = setTimeout(function() {
      toast.classList.remove('is-visible');
      setTimeout(function() { toast.remove(); }, 300);
    }, 1500);
  }

  function showCartNotification(message) {
    console.log('Showing notification:', message);
    
    // Remove existing notification
    const existing = document.querySelector('.bundle-cart-notification');
    if (existing) {
      existing.remove();
    }
    
    // Create notification element
    const notification = document.createElement('div');
    notification.className = 'bundle-cart-notification';
    notification.innerHTML = `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M9 12L11 14L15 10" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
        <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2"/>
      </svg>
      <span>${message}</span>
    `;
    document.body.appendChild(notification);
    
    // Trigger animation
    setTimeout(() => {
      notification.classList.add('show');
    }, 10);
    
    // Remove after 3 seconds
    setTimeout(() => {
      notification.classList.remove('show');
      setTimeout(() => {
        notification.remove();
      }, 300);
    }, 3000);
  }

})();
